enum CaregiverRelationship {
  BIOLOGICAL_PARENT = "BIOLOGICAL_PARENT",
  ADOPTIVE_PARENT = "ADOPTIVE_PARENT",
  FOSTER_PARENT = "FOSTER_PARENT",
  STEP_PARENT = "STEP_PARENT",
  MATERNAL_GRANDPARENT = "MATERNAL_GRANDPARENT",
  PATERNAL_GRANDPARENT = "PATERNAL_GRANDPARENT",
  SIBLING = "SIBLING",
  HALF_SIBLING = "HALF_SIBLING",
  STEP_SIBLING = "STEP_SIBLING",
  UNCLE_AUNT = "UNCLE_AUNT",
  OTHER_RELATIVE = "OTHER_RELATIVE",
  OTHER = "OTHER",
}

export default CaregiverRelationship;
